import cx from 'classnames';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import Link from '../Link';
import TranslationProvider, { getTranslation } from '../../providers/TranslationProvider';

import './Sidenav.scss';
import Rga, { RGA_VARIANT } from '../Rga';
import { getPageContext } from '../../utils';

const Sidenav = ({
  Analytics,
  items,
  userIsConcierge,
  userIsGlobalDiningAccess,
}) => {
  const handleButtonClick = useCallback((handler) => {
    if (!userIsGlobalDiningAccess) {
      const { pathname } = window.location;
      Analytics?.event('view gda module', {
        context: getPageContext(pathname),
        type: 'non GDA',
      });
    }
    handler?.();
  }, [Analytics, userIsGlobalDiningAccess]);

  return (
    <nav aria-label={getTranslation({ translationKey: 'account', fallback: 'Account' })}>
      <ul className="Sidenav">
        {
            items.map(
              ({
                isConcierge,
                isSelected,
                path: href,
                translationKey,
                name,
                onClick,
              }) => {
                if (isConcierge && !userIsConcierge) {
                  return null;
                }

                const translation = (
                  <TranslationProvider translationKey={translationKey}>
                    <span>{name}</span>
                  </TranslationProvider>
                );

                if (href) {
                  return (
                    <li key={name} className={cx({ Sidenav__Selected: isSelected })}>
                      <Link variant="sidenav" href={href} onClick={onClick} aria-current={isSelected}>
                        {translation}
                      </Link>
                    </li>
                  );
                }

                return (
                  <li key={name}>
                    <Button variant="sidenav" onClick={() => handleButtonClick(onClick)}>
                      <Rga variant={RGA_VARIANT.small} />
                    </Button>
                  </li>
                );
              }
            )
            }
      </ul>
    </nav>
  );
};

const sidenavPropTypes = {
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      isConcierge: PropTypes.bool,
      isSelected: PropTypes.bool,
      onClick: PropTypes.func,
      name: PropTypes.string,
      translationKey: PropTypes.string,
    })
  ).isRequired,
  userIsConcierge: PropTypes.bool,
  userIsGlobalDiningAccess: PropTypes.bool,
};

Sidenav.propTypes = sidenavPropTypes;

Sidenav.defaultProps = {
  userIsConcierge: false,
  userIsGlobalDiningAccess: false,
};

export { sidenavPropTypes };
Sidenav.displayName = 'Sidenav';
export default React.memo(Sidenav);
